import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Builds a simple ES module that imports a list of other modules you provide,
and then re-exports those modules in order as an array.
Useful for building extensible navigation lists, routes, strategies, etc.`}</p>
    <p>{`This class uses `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/loaders/export-esm-collection-loader.js"
      }}>{`export-esm-collection-loader`}</a>{` to build the source code.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#TargetableESModuleArray"
        }}>{`TargetableESModuleArray`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModuleArray+addImport"
            }}>{`.addImport(importString)`}</a>{` ⇒ `}<inlineCode parentName="li">{`undefined`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModuleArray+add"
            }}>{`.add(...items)`}</a>{` ⇒ `}<inlineCode parentName="li">{`undefined`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModuleArray+push"
            }}>{`.push(...importString)`}</a>{` ⇒ `}<inlineCode parentName="li">{`undefined`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModuleArray+unshift"
            }}>{`.unshift(...importString)`}</a>{` ⇒ `}<inlineCode parentName="li">{`undefined`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`Adds a module to the end of the array.`}</p>
    <p>{`This also acts as an alias for the `}<inlineCode parentName="p">{`push()`}</inlineCode>{` function.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`importString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A static import declaration for a module`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Add a module or modules to the end of the array.`}</p>
    <p>{`This also acts as an alias for the `}<inlineCode parentName="p">{`push()`}</inlineCode>{` function.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...items`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Static import declaration(s)`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Add a module or modules to the end of the array.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...importString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Static import declaration(s)`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Add a module or modules to the `}<em parentName="p">{`beginning`}</em>{` of the array.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...importString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Static import declaration(s)`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableESModuleArray.js"
      }}>{`pwa-studio/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableESModuleArray.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      